import { TagPlusIcon } from './TagPlusIcon';

/**
 * author: Michael Richins
 * id 83C0C7C5-26FF-4EF7-A05B-B05472FC40FC
 * name tag-plus
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tag-plus.svg
 * tags
 */
export const TagAddIcon = TagPlusIcon;
export default TagAddIcon